import React, { Component } from "react";
import PropTypes from "prop-types";
import Form from "react-bootstrap/lib/Form";
import Col from "react-bootstrap/lib/Col";

import { Question } from "./Question";
import { QuestionBudget } from "./QuestionBudget";
import { ProjectType } from "../../../utils/enums";

export class QuestionContainer extends Component {
  render() {
    return (
      <React.Fragment>
        <Form.Row>
          <Col>
            {this.props.items.map((item, index) => {
              let errors =
                this.props.errors &&
                this.props.errors.questions &&
                this.props.errors.questions.length > 0
                  ? this.props.errors.questions[index]
                  : undefined;

              let questionAnswer = item.answers[0];

              return this.props.projectType !== ProjectType.PublicBudget ? (
                <div
                  className={`margin-bottom-60 ${
                    this.props.subQuestion ? "margin-left-60" : ""
                  }`}
                  key={index}
                >
                  <Question
                    key={index}
                    {...item}
                    questionAnswer={questionAnswer}
                    disabled={this.props.disabled}
                    loggedUserId={this.props.loggedUserId}
                    prefixName={`${this.props.prefixName}questions.${index}.`}
                    formIndex={this.props.formIndex}
                    categoryIndex={this.props.categoryIndex}
                    categoryId={this.props.categoryId}
                    questionIndex={index}
                    rowId={index + 1}
                    projectType={this.props.projectType}
                    consultationFormType={this.props.consultationFormType}
                    onChange={this.props.onChange}
                    onBlur={this.props.onBlur}
                    setFieldValue={this.props.setFieldValue}
                    errors={errors}
                    isAuth={this.props.isAuth}
                    subQuestion={this.props.subQuestion}
                    isPreview={this.props.isPreview}
                  />
                </div>
              ) : (
                <div className="budget" key={index}>
                  <QuestionBudget
                    {...item}
                    prefixName={`${this.props.prefixName}questions.${index}.`}
                    formIndex={this.props.formIndex}
                    categoryIndex={this.props.categoryIndex}
                    categoryId={this.props.categoryId}
                    questionIndex={index}
                    questionAnswer={questionAnswer}
                    rowId={index + 1}
                    disabled={this.props.disabled}
                    loggedUserId={this.props.loggedUserId}
                    projectType={this.props.projectType}
                    consultationFormType={this.props.consultationFormType}
                    onChange={this.props.onChange}
                    onBlur={this.props.onBlur}
                    setFieldValue={this.props.setFieldValue}
                    errors={errors}
                    isAuth={this.props.isAuth}
                    availableVoteNotLogged={this.props.availableVoteNotLogged}
                  />
                </div>
              );
            })}
          </Col>
        </Form.Row>
      </React.Fragment>
    );
  }
}

QuestionContainer.propTypes = {
  categoryId: PropTypes.number,
  categoryIndex: PropTypes.number,
  consultationFormType: PropTypes.number,
  disabled: PropTypes.bool,
  formIndex: PropTypes.number,
  isResultPublished: PropTypes.bool,
  loggedUserId: PropTypes.number,
  projectType: PropTypes.number,

  items: PropTypes.arrayOf(
    PropTypes.shape({
      canComment: PropTypes.bool,
      content: PropTypes.string,
      id: PropTypes.number,
      maxPoint: PropTypes.number,
      order: PropTypes.number,
      questionOptionCount: PropTypes.number,
      questionResultQuantitySum: PropTypes.number,
      questionType: PropTypes.number,
      questionOptionCount: PropTypes.number,
      answers: PropTypes.arrayOf(
        PropTypes.shape({
          categoryId: PropTypes.number,
          id: PropTypes.number,
          questionId: PropTypes.number,
          userId: PropTypes.number,
          answerOptions: PropTypes.arrayOf(
            PropTypes.shape({
              comment: PropTypes.string,
              id: PropTypes.number,
              openDate: PropTypes.string,
              openText: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number,
              ]),
              questionMatrixValueId: PropTypes.number,
              questionOptionId: PropTypes.number,
              ranking: PropTypes.number,
            })
          ),
        })
      ),
      questionMatrixValues: PropTypes.arrayOf(
        PropTypes.shape({
          content: PropTypes.string,
          id: PropTypes.number,
          order: PropTypes.number,
        })
      ),
      questionOptions: PropTypes.arrayOf(
        PropTypes.shape({
          content: PropTypes.string,
          id: PropTypes.number,
          order: PropTypes.number,
        })
      ),
      questionResults: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number,
          quantity: PropTypes.number,
          questionOptionName: PropTypes.string,
        })
      ),
    })
  ),

  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  setFieldTouched: PropTypes.func,
  setFieldValue: PropTypes.func,
};

QuestionContainer.defaultProps = {
  subQuestion: false,
  categoryId: 0,
  categoryIndex: 0,
  consultationFormType: 0,
  disabled: false,
  formIndex: 0,
  isResultPublished: false,
  loggedUserId: 0,
  projectType: 0,

  items: [],

  onBlur: Function.prototype,
  onChange: Function.prototype,
  setFieldTouched: Function.prototype,
  setFieldValue: Function.prototype,
};
